// src/lib/zipLookup.js
// Free US zip → city/state lookup via Zippopotam.us. No API key needed.
// Returns { city, state } or null. Caches in-memory so the same zip
// isn't hit twice.

const cache = new Map();

export async function lookupZip(zip) {
  const z = String(zip || '').trim();
  if (!/^\d{5}$/.test(z)) return null;
  if (cache.has(z)) return cache.get(z);
  try {
    const r = await fetch(`https://api.zippopotam.us/us/${z}`);
    if (!r.ok) { cache.set(z, null); return null; }
    const data = await r.json();
    const place = data?.places?.[0];
    if (!place) { cache.set(z, null); return null; }
    const result = {
      city: place['place name'] || '',
      state: place['state abbreviation'] || ''
    };
    cache.set(z, result);
    return result;
  } catch {
    return null;
  }
}
